// @flow

import axios from "axios";
import { EXTERNAL_CONNECTION_ERRORS } from "./constants";

const createNewModule = async (appName: string) => {
  try {
    const recordRequest = await axios.post(`/api/shared/create-new-module`, {
      data: {
        appName: appName
      }
    });
    const { data } = recordRequest;
    return data;
  } catch (error) {
    console.error("Utils - Create New Module - Error:", error);
    throw new Error(EXTERNAL_CONNECTION_ERRORS.GET_RECORD);
  }
};

export default createNewModule;
